import React from 'react'
import { Icon, Label } from 'semantic-ui-react'

export default class HighDemandInfo extends React.PureComponent {
  render() {
    const { order } = this.props

    if (!order.peak_mode) return null

    return (
      <React.Fragment>
        <hr style={{ margin: '3px 0px 0px 0px' }} />
        <div>
          <Label color="red" style={{ margin: '3px 3px 0px 0px' }}>
            <Icon name="line chart" />
            High Demand
          </Label>

          {order.high_traffic_visible === false && (
            <Label color="red" style={{ margin: '3px 0px' }}>
              <Icon name="hide" style={{ marginRight: 0 }} />
            </Label>
          )}
        </div>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/orders/components/OrderListItem/HighDemandInfo.js